import React from 'react';
import PropTypes from 'prop-types';

import { makeListingFullAddressString } from 'common/listingHelpers';

import { hasRoleShadowBanned } from 'common/userRoles';

import {
  MANUAL_ID_VERIFICATION_STATUS_APPROVED,
  MANUAL_ID_VERIFICATION_STATUS_REJECTED,
  MANUAL_ID_VERIFICATION_STATUS_RETRY,
} from 'common/manualIdVerificationConstants';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrExternalLink from 'client/components/SrExternalLink';
import SrSeparator from 'client/components/SrSeparator';
import SrFlex from 'client/components/SrFlex';
import ButtonDeprecated, {
  BUTTON_THEME_GREEN_ADOBE,
  BUTTON_THEME_RED_ADOBE,
  BUTTON_THEME_GREY_ADOBE,
} from 'client/components/ButtonDeprecated';
import SrErrorMessage from 'client/components/SrErrorMessage/SrErrorMessage';

const SrReviewManualIdVerification = ({ manualIdVerification, reviewManualIdVerification }) => {
  const { user, idVerification, listing } = manualIdVerification;

  return (
    <SrBox marginTop="10px">
      <SrBox margin="20px 0">
        <SrSeparator />
      </SrBox>

      <SrBox marginBottom="20px">
        <SrText display="block" font="greycliff" size="20" weight="700">
          Renter
        </SrText>
        <SrText display="block" font="greycliff" size="16" weight="500">
          {user.name}
        </SrText>
        <SrText display="block" font="greycliff" size="16" weight="500">
          {user.phone}
        </SrText>
        <SrText display="block" font="greycliff" size="16" weight="500">
          {user.email}
        </SrText>
      </SrBox>

      <SrBox marginBottom="20px">
        <SrText font="greycliff" size="20" weight="700">
          Listing
        </SrText>
        <SrText display="block" font="greycliff" size="16" weight="500">
          {makeListingFullAddressString(listing)}
        </SrText>
      </SrBox>

      <SrBox marginBottom="20px">
        <SrText font="greycliff" size="20" weight="700">
          Vouched Link
        </SrText>
        {idVerification.vouchedJob?.id ? (
          <SrExternalLink
            link={`https://app.vouched.id/account/jobs/${idVerification.vouchedJob.id}`}
          >
            <SrText
              cursor="pointer"
              color="blue300"
              display="block"
              font="greycliff"
              size="21"
              weight="700"
            >
              See Vouched Job
            </SrText>
          </SrExternalLink>
        ) : (
          <SrText display="block" font="greycliff" size="16" weight="500">
            Vouched job not found!
          </SrText>
        )}
      </SrBox>

      {hasRoleShadowBanned(user.roles) && (
        <SrBox marginBottom="20px">
          <SrErrorMessage>
            This user is currently shadowbanned. Approving them here will remove the shadowban.
          </SrErrorMessage>
        </SrBox>
      )}

      <SrFlex>
        <SrBox width="200px">
          <ButtonDeprecated
            type="button"
            theme={BUTTON_THEME_GREEN_ADOBE}
            onClick={() =>
              reviewManualIdVerification({
                status: MANUAL_ID_VERIFICATION_STATUS_APPROVED,
                manualIdVerificationId: manualIdVerification.id,
              })
            }
          >
            Approve
          </ButtonDeprecated>
        </SrBox>

        <SrBox marginLeft="20px" width="200px">
          <ButtonDeprecated
            type="button"
            theme={BUTTON_THEME_RED_ADOBE}
            onClick={() =>
              reviewManualIdVerification({
                status: MANUAL_ID_VERIFICATION_STATUS_REJECTED,
                manualIdVerificationId: manualIdVerification.id,
              })
            }
          >
            Reject
          </ButtonDeprecated>
        </SrBox>

        <SrBox marginLeft="20px" width="200px">
          <ButtonDeprecated
            type="button"
            theme={BUTTON_THEME_GREY_ADOBE}
            onClick={() =>
              reviewManualIdVerification({
                status: MANUAL_ID_VERIFICATION_STATUS_RETRY,
                manualIdVerificationId: manualIdVerification.id,
              })
            }
          >
            Try Again
          </ButtonDeprecated>
        </SrBox>
      </SrFlex>
    </SrBox>
  );
};

SrReviewManualIdVerification.propTypes = {
  manualIdVerification: PropTypes.object.isRequired,
  reviewManualIdVerification: PropTypes.func.isRequired,
};

SrReviewManualIdVerification.displayName = 'SrReviewManualIdVerification';

export default SrReviewManualIdVerification;
